import { render, staticRenderFns } from "./ProgramWorkouts.vue?vue&type=template&id=171e01c2&scoped=true&"
import script from "./ProgramWorkouts.vue?vue&type=script&lang=js&"
export * from "./ProgramWorkouts.vue?vue&type=script&lang=js&"
import style0 from "./ProgramWorkouts.vue?vue&type=style&index=0&id=171e01c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "171e01c2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VBtn,VCard,VCardText,VCardTitle,VChip,VCol,VDivider})
